import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-case-declarations */

/* eslint-disable prefer-destructuring */

/* eslint-disable consistent-return */
import React, { createContext, useReducer, useMemo, useEffect } from 'react';
import { formatters } from '@mummssoftware/utils';
import { SET_REPORT_DATA, SET_API_PARAM, SET_INIT_API_PARAMS, SET_SHOW_LOADER } from './constants';
import { getDefaultParams } from './utils';

const initFunc = props => null;

const initialState = {
  reportData: null,
  apiParams: null,
  runReport: initFunc,
  showLoader: false,
  exportReportAsCSV: initFunc,
  dispatch: initFunc
};
const initReportContext = {
  reportData: null,
  apiParams: null,
  runReport: initFunc,
  showLoader: false,
  exportReportAsCSV: initFunc,
  dispatch: initFunc
};
export const ReportContextReducer = (state, action) => {
  let newState = _objectSpread({}, state);

  switch (action.type) {
    case SET_REPORT_DATA:
      newState.reportData = action.payload;
      break;

    case SET_INIT_API_PARAMS:
      newState.apiParams = action.payload;
      break;

    case SET_API_PARAM:
      if (newState.apiParams === null) {
        newState.apiParams = {};
      }

      newState.apiParams[action.payload.id] = action.payload.value;
      break;

    case SET_SHOW_LOADER:
      newState.showLoader = action.payload;
      break;

    default:
      newState = state;
      break;
  }

  return newState;
};
export const ReportContext = /*#__PURE__*/createContext(initReportContext);
export const ReportDispatchContext = /*#__PURE__*/createContext({});
export const ReportContextConsumer = ReportContext.Consumer;
export const ReportDispatchContextConsumer = ReportDispatchContext.Consumer;
export const ReportContextProvider = ({
  reporting,
  agency,
  reportHeader,
  children,
  gridAPIRef
}) => {
  const [{
    reportData,
    apiParams,
    showLoader
  }, dispatch] = useReducer(ReportContextReducer, initialState);
  useEffect(() => {
    if (reportHeader) {
      dispatch({
        type: SET_INIT_API_PARAMS,
        payload: getDefaultParams(reportHeader.reportParams)
      });
    }
  }, [reportHeader]);

  const runReport = async shortName => {
    const response = await reporting.runReport(shortName, agency, apiParams);

    if (!(response instanceof Response)) {
      dispatch({
        type: SET_REPORT_DATA,
        payload: response.reportData
      });
    }
  };

  const exportReportAsCSV = () => {
    if (gridAPIRef === null) return;
    const reportDate = formatters.YYYYMMDDtoMMDDYY(new Date().toISOString());
    gridAPIRef.current.exportDataAsCsv({
      allColumns: true,
      fileName: `${reportHeader.name}_${agency}_${reportDate}`
    });
  };

  const context = useMemo(() => ({
    reportData,
    apiParams,
    runReport,
    showLoader,
    exportReportAsCSV,
    dispatch
  }), [reportData, apiParams, runReport, showLoader, exportReportAsCSV, dispatch]);
  return /*#__PURE__*/React.createElement(ReportContext.Provider, {
    value: context
  }, children);
};
export function withReportContext(Component) {
  return function contextComponent(props) {
    return /*#__PURE__*/React.createElement(ReportContextConsumer, null, context => /*#__PURE__*/React.createElement(ReportDispatchContextConsumer, null, dispatchContext => /*#__PURE__*/React.createElement(Component, _extends({}, props, context, dispatchContext))));
  };
}
export default ReportContext;